import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import AButton from '../../atoms/_atoms.button';

export default function OHouseHoldIntro({ onClick }) {
	return (
		<section className="section-xx o-section-household-intro">
			<article>
				<p className="title--light">
					<FormattedMessage id="HOUSE_HOLD.INTRO_TITLE" defaultMessage="" />
				</p>
				<p className="sub-title">
					<FormattedMessage id="HOUSE_HOLD.INTRO_SUB_TITLE" defaultMessage="" />
				</p>
				<p className="body">
					<FormattedMessage id="HOUSE_HOLD.INTRO_BODY" defaultMessage="" />
				</p>
				<AButton
					onClick={onClick}
					value="HOUSE_HOLD.INTRO_BUTTON"
				/>
			</article>
		</section>
	);
}

OHouseHoldIntro.propTypes = {
	onClick: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/organisme/house_hold/_organisme.household-intro.js